import { TextValue, MetadataValue } from 'app/area/company-reports-administration/form/types-store';

export const createInitialText = (id: number) => ({
  id,
  textId: undefined,
  textSet: undefined,
  textDescription: undefined,
  cell: undefined,
  range: undefined
} as TextValue);

export const createInitialMetadata = (id: number) => ({
  id,
  metadataType: undefined,
  cell: undefined,
  range: undefined
} as MetadataValue);

export const createId = (value: TextValue[] | MetadataValue[]) => value.length > 0 ? Math.max(...value.map(item => item.id)) + 1 : 1;
